import {useCallback} from 'react'
import {useShopperBasketsMutation} from '@salesforce/commerce-sdk-react'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import {useBrand} from '../contexts/brand-context'

const DEFAULT_BRAND = 'garage'

/**
 * Returns a function that stamps the current brand on the basket. Call it right before
 * the order is created — the order inherits c_brandId from the basket.
 */
const useBasketBrand = () => {
    const {data: basket} = useCurrentBasket()
    const {brandId} = useBrand()
    const {mutateAsync: updateBasket} = useShopperBasketsMutation('updateBasket')

    return useCallback(async () => {
        const basketId = basket?.basketId
        if (!basketId) return

        const currentBrand = (brandId || DEFAULT_BRAND).toLowerCase()
        if (basket.c_brandId === currentBrand) return

        try {
            await updateBasket({parameters: {basketId}, body: {c_brandId: currentBrand}})
        } catch (e) {
            // A failed stamp must not block order placement
        }
    }, [basket?.basketId, basket?.c_brandId, brandId, updateBasket])
}

export default useBasketBrand
